<template>
  <div>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <v-form v-model="valid">
        <v-select variant="underlined" label="Access Type" v-model="accessType" :items="accessTypes" item-title="value" item-value="key"></v-select>
        <v-checkbox
          v-model="accessToCommunityConfig"
          class="mx-2"
          label="I need access to live community configuration"
        ></v-checkbox>
        <v-checkbox v-model="accessToITSupport" class="mx-2" label="I need access to the IT Support list"></v-checkbox>
        <v-select
          v-model="community"
          variant="underlined"
          label="Community"
          :items="communities"
          item-value="communityAbbreviation"
          item-title="communityName"
          clearable
          :menu-props="{ auto: true }"
        ></v-select>
        <v-select v-model="timeRequested" variant="underlined" label="Access Time" :items="accessTimes" item-title="value" item-value="key"></v-select>
        <v-btn color="green" class="white--text" @click="submit">Submit</v-btn>
      </v-form>
    </v-container>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import AdminService from '@/services/admin.service'
import Toaster from '@/components/Toaster'

export default {
  name: 'DbAccessForm',
  components: {
    Toaster
  },
  data() {
    return {
      valid: false,
      accessTypes: [
        {
          key: 'readonly',
          value: 'Read only'
        },
        {
          key: 'write',
          value: 'Write'
        }
      ],
      accessTimes: [
        {
          key: 0.5,
          value: '30 minutes'
        },
        {
          key: 1,
          value: '1 hour'
        },
        {
          key: 2,
          value: '2 hours'
        },
        {
          key: 4,
          value: '4 hours'
        },
        {
          key: 8,
          value: '8 hours'
        }
      ],
      accessType: 'readonly',
      accessToCommunityConfig: false,
      accessToITSupport: false,
      timeRequested: 0.5,
      community: '',
      communities: [],
      loadingDialog: false
    }
  },
  methods: {
    submit() {
      if (!this.accessToCommunityConfig && !this.accessToITSupport && !this.community) {
        this.$refs.toaster.pop('error', `Please select to what data you would like to have access`)
        return
      }
      if (this.loadingDialog) return
      this.loadingDialog = true
      AdminService.requestTempDbAccess({
        accessType: this.accessType,
        timeRequested: this.timeRequested,
        community: this.community,
        accessToLiveCommunityConfiguration: this.accessToCommunityConfig,
        accessToITSupportCollection: this.accessToITSupport
      })
        .then(() => {
          this.$router.go(0)
        })
        .catch(error => {
          this.$refs.toaster.pop('error', `An error has ocurred ${error.message}`)
        })
        .finally(() => {
          this.loadingDialog = false
        })
    }
  },
  created() {
    AdminService.getAllCommunities().then(
      (result) => (this.communities = result.sort((a, b) => (a.communityName > b.communityName ? 1 : -1)))
    )
  }
}
</script>

<style></style>
